import {QuoteStore} from "./store/QuoteStore";
import {QuoteService} from "./service/QuoteService";
import {quoteChange, QuoteChange} from "./directives/QuoteChangeDirective";

import Component from "./components";
import {QuoteModelFactory} from "./service/QuoteModelFactory";
import {tradingStatePipe, TradingStatePipe} from "./pipes/TradingStatePipe";
import {
    BasisOfQuotationCodePipe,
    basisOfQuotationCodePipe, basisOfQuotationDescriptionPipe,
    BasisOfQuotationDescriptionPipe
} from "./pipes/BasisOfQuotationCodeFilter";
import {ClientEventService} from "../services/client-events/ClientEventService";
import {CurrentUserService} from "../services/user/CurrentUserService";

export default angular.module("tfApp.quote", [Component()])
                      .service(QuoteModelFactory.id, QuoteModelFactory)
                      .service("quoteStore", quoteStore)
                      .service(QuoteService.id, QuoteService)
                      .filter(TradingStatePipe, tradingStatePipe)
                      .filter(BasisOfQuotationCodePipe, basisOfQuotationCodePipe)
                      .filter(BasisOfQuotationDescriptionPipe, basisOfQuotationDescriptionPipe)
                      .directive(QuoteChange, quoteChange)
                      .name;

/** @ngInject */
function quoteStore(quoteService: QuoteService,
                    clientEventService: ClientEventService,
                    quoteModelFactory: QuoteModelFactory,
                    currentUserService: CurrentUserService): QuoteStore {
    return new QuoteStore(quoteService, clientEventService, quoteModelFactory, currentUserService)
}